import { StorageReference, listAll, ref } from "firebase/storage";
import { useState } from "react";
import * as Sentry from "@sentry/react";
import { storage } from "../api/firebaseApi";

export const useGetFilesFromDB = () => {
  const [isLoadingGetFiles, setIsLoadingGetFiles] = useState(false);
  const [storageFiles, setStorageFiles] = useState<StorageReference[]>([]);

  const onSubmitGetFiles = async (
    path: string,
    opts?: { throwOnError?: boolean }
  ) => {
    const imageListRef = ref(storage, path);
    setIsLoadingGetFiles(true);

    try {
      const images = await listAll(imageListRef);
      setStorageFiles(images.items);
      return images.items;
    } catch (error) {
      Sentry.captureException(error);
      if (opts?.throwOnError) throw error;
    } finally {
      setIsLoadingGetFiles(false);
    }
    return [];
  };

  return {
    isLoadingGetFiles,
    storageFiles,
    onSubmitGetFiles
  };
};
